import Requester from '../Requester';

const getDelivery = (id) => {
    Requester.get('https://api.bemyzing.com/api/v1/')
};

const getDeliveryQuote = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "deliveries/quote", "", data)
};

const getDeliveryTrackingDetails = (trackingId) => {
    return Requester.makeRequest(Requester.methods.GET, "deliveries/" + trackingId + "/tracking")
};

// const getRiderPendingDeliveries = (userPhone) => {
//     return Requester.makeRequest(Requester.GET, "agents/" + userPhone + "/deliveries")
// };
//
// const getRiderSingleDelivery = (userPhone, id) => {
//     return Requester.makeRequest(Requester.GET, "agents/" + userPhone + "/deliveries/" + id)
// };
//
// const riderUpdateDeliveryStatus = (userPhone, id, data) => {
//     return Requester.makeRequest(Requester.methods.PUT, "agents/" + userPhone + "/deliveries/" + id, "", data)
// };

export default {
    getDelivery: getDelivery,
    quote: getDeliveryQuote,
    tracking: getDeliveryTrackingDetails
}
